export default "__VITE_ASSET__18ede853__"